export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14082.7de1693c.jpg";